<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col align-h="center" cols="12" md="4" lg="3">
                        <app-autocomplete
                            placeholder="Cliente"
                            :items="clients"
                            v-model="selectClient"
                        />
                    </b-col>
                    <b-col align-h="center" cols="12" md="4" lg="3">
                        <app-form-select-input placeholder="Tipo de anotación" :options="typesAnnotation" v-model="filters.type"></app-form-select-input>
                    </b-col>
                    <b-col cols="12" md="4" lg="2">
                        <app-autocomplete
                            placeholder="Supervisor"
                            :items="authors"
                            v-model="selectSupervisor"
                        /> 
                    </b-col>
                    <b-col cols="6" md="4" lg="2">
                        <app-date-time-picker id="from" placeholder="Desde" v-model="filters.from" :with-time="false"></app-date-time-picker>
                    </b-col>
                    <b-col cols="6" md="4" lg="2">
                        <app-date-time-picker id="to" placeholder="Hasta" v-model="filters.to" :with-time="false"></app-date-time-picker>
                    </b-col>
                    <b-col cols="12" md="2" lg="1" offset-lg="10">
                        <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    </b-col>
                    <b-col cols="12" md="2" lg="1">
                        <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import DateTimePicker from "../../../../UI/Controls/DateTimePicker/DateTimePicker.vue";
import Autocomplete from '../../../../UI/Controls/AutocompleteV2/Autocomplete.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
        appDateTimePicker: DateTimePicker,
        appAutocomplete: Autocomplete
    },
    props: {
        authors: {
            type: Array
        },
        typesAnnotation: {
            type: Array
        }

    },
    data(){
        return {
            filters: {
                type: '',
                author: '',
                from: '',
                to: '',
                client: ''
            },
            selectClient: '',
            selectSupervisor: ''
        }
    },
    watch:{
        selectClient(val){
            if(!val){
                this.filters.client= '';
                this.selectClient = '';
            }else{
                this.filters.client = val.id;
            }
        },
        selectSupervisor(val){
            if(!val){
                this.filters.author= '';
                this.selectSupervisor = '';
            }else{
                this.filters.author = val.id;
            }
        }
    },
    computed: {
        ...mapGetters(['clients'])
    },
    methods: {
        clearFilters(){
            this.selectClient= '';
            this.selectSupervisor = '';
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    }
}
</script>

